import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Footer.css';

function Footer() {
  const { t } = useTranslation();

  const handleMobileAppClick = (e) => {
    e.preventDefault();
    alert(t('footer.mobileAppsComing'));
  };

  return (
    <>
      <footer className="main-footer">
        <div className="footer-container">
          {/* Left column - Logo and description */}
          <div className="footer-brand">
            <a href="/" className="logo">
              <img src="/assets_landing/img/trace.svg" alt="TraderMap" title="TraderMap" />
              <small>{t('footer.allRightsReserved')}</small>
            </a>
            <p>{t('footer.description')}</p>
            <div className="footer-buttons">
              <Link to="/widgets">Widgets</Link>
              <a href="#" onClick={handleMobileAppClick}>Google Play</a>
              <a href="#" onClick={handleMobileAppClick}>App Store</a>
            </div>
          </div>

          {/* Right columns - Links grid */}
          <div className="footer-links">
            <div className="footer-column">
              <div className="footer-title">{t('footer.legal')}</div>
              <ul>
                <li>
                  <Link to="/privacy">{t('footer.privacyPolicy')}</Link>
                </li>
                <li>
                  <Link to="/terms">{t('footer.termsOfUse')}</Link>
                </li>
                <li>
                  <Link to="/disclaimer">{t('footer.disclaimer')}</Link>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <div className="footer-title">{t('footer.topCoins')}</div>
              <ul>
                <li><a href="/price/BTC">Bitcoin</a></li>
                <li><a href="/price/ETH">Ethereum</a></li>
                <li><a href="/price/HYPE">Hype</a></li>
              </ul>
            </div>
            <div className="footer-column">
              <div className="footer-title">{t('footer.socialMedia')}</div>
              <ul>
                <li><a href="https://x.com/tradermap_io" target="_blank" rel="noopener noreferrer">Twitter</a></li>
                <li><a href="https://t.me/tradermap_io" target="_blank" rel="noopener noreferrer">Telegram</a></li>
                <li><a href="mailto:support@tradermap.io">support@tradermap.io</a></li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
